import Vue from "vue";
import VueRouter from "vue-router";

import Home from "../views/Home.vue";


Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,

  },
  {
    path: '/consecutivo',
    name: 'consecutivo',
    component:()=>
    import('../views/consecutivo.vue') 
  
  },
  {
    path: '/referencias',
    name: 'referencias',
    component:()=>
    import('../views/referencias.vue') 
  
  },
  {
    path: '/Informes',
    name: 'Informes',
    component:()=>
    import('../views/Informes.vue') 
  
  },
  {
    path: '/tipodedocumentos',
    name: 'tipodedocumentos',
    component:()=>
    import('../views/tipodedocumentos.vue') 
  
  },
  {
    path: '/descuentos',
    name: 'descuentos',
    component:()=>
    import('../views/descuentos.vue') 
  
  },


  { path:'/transportistas',
  name:'transportistas',
  component:()=>
  import('../views/transportistas.vue')

  },
  { 
    path:'/productos',
    name:'productos',
    component :() =>
    import('../views/productos.vue')

  },
  {
    path: "/pedidos",
    name: "pedidos",
    // route level code-splitting
    // this generates a separate chunk (.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "ab" */ "../views/pedidos.vue")

  },
  {
    path: '/caracteristicas',
    name: 'caracteristicas',
    component:()=>
    import('../views/caracteristicas.vue') 
  
  },
  {
    path:'/clientes',
    name:'clientes',
    component :() =>
    import('../views/clientes.vue')
  }
];
const router = new VueRouter({
  routes
});

export default router;
